// Provable completeness = a final segment was received (segmentsExpected > 0) AND
// every index 0..expected-1 is present (no interior gap). NEVER trusts percent /
// segmentsReceived (high-water marks — a lost middle segment still reads ~100%).
// Spec §4. The ONLY condition under which a cross-device pull may attach SILENTLY;
// anything else must nudge, never silently attach a partial transcript.
export function isProvablyComplete({ segmentsExpected, presentIndices }) {
  if (typeof segmentsExpected !== "number" || segmentsExpected <= 0) return false;
  if (!Array.isArray(presentIndices)) return false;
  const present = new Set(presentIndices);
  for (let i = 0; i < segmentsExpected; i++) if (!present.has(i)) return false;
  return true;
}
